import { render } from "./milestone-form-footer-save-as-draft-button.vue?vue&type=template&id=aaa1d3f8&scoped=true&ts=true"
import script from "./milestone-form-footer-save-as-draft-button.vue?vue&type=script&lang=ts"
export * from "./milestone-form-footer-save-as-draft-button.vue?vue&type=script&lang=ts"

import "./milestone-form-footer-save-as-draft-button.vue?vue&type=style&index=0&id=aaa1d3f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaa1d3f8"]])

export default __exports__